import {
  withGetFragmentTable,
  withInsertFragmentTable,
  withInsertTextTable,
  withNormalizeTable,
  withSelectionTable,
  withDeleteTable,
  withMarkTable,
  getTableGridAbove,
} from '@udecode/plate-table';
import { isCollapsed } from '@udecode/plate-common';

import { withSetFragmentDataTable } from './withSetFragmentDataTable';
import { withNormalizeUnbalancedTables } from './withNormalizeUnbalancedTables';
import { withNormalizeTableNodeIds } from './withNormalizeTableNodeIds';
import { withNormalizeTable2 } from './withNormalizeTable2';
import { withSafeTable } from './withSafeTable';


export const withTable = (
  editor,
  plugin,
) => {
  let _editor = editor;
  _editor = withNormalizeTable2(editor);
  _editor = withNormalizeTable(editor);
  _editor = withDeleteTable(editor);
  _editor = withGetFragmentTable(editor, plugin);
  _editor = withInsertFragmentTable(editor, plugin);
  _editor = withInsertTextTable(editor, plugin);
  _editor = withSelectionTable(editor);
  _editor = withSetFragmentDataTable(editor);

  // Capture Slate's default implementations before withMarkTable overrides them.
  // withMarkTable has a bug where getMarks and removeMark use `=== 0` instead of
  // `<= 1` as the single-cell guard, causing marks to bleed across all paragraphs
  // in the same cell when only part of the cell is selected.
  const slateGetMarks = editor.getMarks.bind(editor);
  const slateRemoveMark = editor.removeMark.bind(editor);

  _editor = withMarkTable(editor);

  const plateGetMarks = editor.getMarks.bind(editor);
  const plateRemoveMark = editor.removeMark.bind(editor);

  editor.getMarks = () => {
    const { selection } = editor;
    if (!selection || isCollapsed(selection)) return slateGetMarks();
    const matchesCell = getTableGridAbove(editor, { format: 'cell' });
    if (matchesCell.length <= 1) return slateGetMarks();
    return plateGetMarks();
  };

  editor.removeMark = (key) => {
    const { selection } = editor;
    if (!selection || isCollapsed(selection)) return slateRemoveMark(key);
    const matchesCell = getTableGridAbove(editor, { format: 'cell' });
    if (matchesCell.length <= 1) return slateRemoveMark(key);
    return plateRemoveMark(key);
  };

  _editor = withNormalizeUnbalancedTables(editor);
  _editor = withNormalizeTableNodeIds(editor);
  _editor = withSafeTable(editor);

  return _editor;
};
